<div class="view-container">
  <mat-card *authGroup="['SuperAdmin', 'OperationsManager']" class="user-list-container">
    <div class="user-list__header">
      <div class="mbp-page-header">
        <div class="mbp-page-header__icon">
          <mat-icon>group</mat-icon>
        </div>
        <h1 class="mbp-page-header__title">Users</h1>
      </div>

      <div class="user-list__filters">
        <mat-form-field
          appearance="outline"
          class="user-list__filter user-list__filter--search"
          subscriptSizing="dynamic"
        >
          <input
            matInput
            [formControl]="searchControl"
            placeholder="Search name, email or phone"
          />
          <mat-icon matPrefix>search</mat-icon>
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="user-list__filter user-list__filter--search"
          subscriptSizing="dynamic"
        >
          <input
            matInput
            [formControl]="practiceSearchControl"
            placeholder="Company or individual name"
          />
          <mat-icon matPrefix>business</mat-icon>
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="user-list__filter user-list__filter--status"
          subscriptSizing="dynamic"
        >
          <mat-label>Account status</mat-label>
          <mat-select [formControl]="enabledFilter">
            <mat-option value="enabled_only">Enabled</mat-option>
            <mat-option value="all">All</mat-option>
            <mat-option value="disabled">Disabled</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="mbp-table-wrap">
      <table mat-table [dataSource]="usersDataSource" class="mbp-data-table user-list">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef class="name-col">Name</th>
          <td mat-cell *matCellDef="let user" class="name-col">
            {{ getAttribute('name', user) || '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="email">
          <th mat-header-cell *matHeaderCellDef>Email</th>
          <td mat-cell *matCellDef="let user">
            {{ getAttribute('email', user) || '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="phone_number">
          <th mat-header-cell *matHeaderCellDef>Phone number</th>
          <td mat-cell *matCellDef="let user">
            {{ getAttribute('phone_number', user) || '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="company_or_individual">
          <th mat-header-cell *matHeaderCellDef>Company / Individual</th>
          <td mat-cell *matCellDef="let user">
            {{ getCompanyOrIndividualLabel(user) || '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let user">
            {{ normalizeText(user.UserStatus) || '-' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="enabled">
          <th mat-header-cell *matHeaderCellDef>Enabled</th>
          <td mat-cell *matCellDef="let user">
            <mat-icon
              class="user-list__enabled-icon"
              [class.user-list__enabled-icon--active]="isUserEnabled(user)"
            >
              done
            </mat-icon>
          </td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef class="action-col">&nbsp;</th>
          <td mat-cell *matCellDef="let user" class="action-col">
            @if (isUserEnabled(user)) {
              <button
                type="button"
                mat-stroked-button
                class="user-list__row-btn user-list__row-btn--warn"
                (click)="disableUser($event, user)"
              >
                Disable
              </button>
            }
            @if (!isUserEnabled(user)) {
              <button
                type="button"
                mat-flat-button
                color="primary"
                class="user-list__row-btn user-list__row-btn--primary"
                (click)="enableUser($event, user)"
              >
                Enable
              </button>
            }
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          (click)="viewUser(row)"
          *matRowDef="let row; columns: displayedColumns"
        ></tr>

        <tr class="user-list__empty-row" *matNoDataRow>
          <td class="user-list__empty-cell" [attr.colspan]="displayedColumns.length">
            No users match the current filters.
          </td>
        </tr>
      </table>
    </div>

    <div class="user-list__pager">
      <mat-form-field
        appearance="outline"
        class="user-list__pager-size"
        subscriptSizing="dynamic"
      >
        <mat-label>Per page</mat-label>
        <mat-select [formControl]="perPageControl">
          <mat-option value="10">10</mat-option>
          <mat-option value="15">15</mat-option>
          <mat-option value="20">20</mat-option>
        </mat-select>
      </mat-form-field>

      <div class="user-list__pager-nav">
        @if (page > 1) {
          <button
            type="button"
            [disabled]="loading"
            (click)="lastPage()"
            mat-stroked-button
            class="user-list__pager-btn"
          >
            Prev
          </button>
        }
        @if (nextToken) {
          <button
            type="button"
            [disabled]="loading"
            (click)="nextPage()"
            mat-stroked-button
            class="user-list__pager-btn"
          >
            Next
          </button>
        }
      </div>
    </div>
  </mat-card>
</div>
